import { Navigate } from "react-router-dom";
import Dashboard from '../modules/Dashboard/pages';
import OfflinePage from "../Components/Common/Offline";
import Login from "../modules/Auth/pages/Login";
import Logout from "../modules/Auth/pages/Logout";
import LockScreen from "../modules/Auth/pages/Lock";
import Vehicules from "../modules/Vehicules/pages";
import Drivers from "../modules/Drivers/pages";
import Inspections from "../modules/Inspections/pages";
import HelpPage from "../modules/Help/pages";
import Users from "../modules/Users/pages";
import Roles from "../modules/Users/pages/userRole";
import Catalogs from "../modules/Catalogue/pages";
import MyProfile from "../modules/Profiles/pages";
import ForgetPassword from "../modules/Auth/components/forgetPassword";
import Incidents from "../modules/Inspections/pages/incident";
import AllNotifications from "../modules/Notifications/pages";
import Stocke from "../modules/Materiels/pages/stocke";
import DemandeMateriel from "../modules/Materiels/pages";


const authProtectedRoutes = [
  { path: "/dashboard", component: <Dashboard /> },
  { path: "/profiles", component: <MyProfile /> },
  { path: "/", exact: true, component: <Navigate to="/dashboard" />,},
  { path: "*", component: <Navigate to="/dashboard" /> },
  { path: "/vehicles", component: <Vehicules /> },
  { path: "/drivers", component: <Drivers /> },
  { path: "/inspections", component: <Inspections /> },
  { path: "/help", component: <HelpPage /> },
  { path: "/utilisateurs", component: <Users /> },
  { path: "/roles", component: <Roles /> },
  { path: "/statut", component: <Catalogs /> },
  { path: "/incidents", component: <Incidents /> },
  { path: "/notifications", component: <AllNotifications /> },
  { path: "/demandes-materiels", component: <DemandeMateriel /> },
  { path: "/stocke", component: <Stocke /> },
];

const publicRoutes = [
  { path: "/lock", component: <LockScreen /> },
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/update-password", component: <ForgetPassword /> },
  { path: "/offline", component: <OfflinePage /> },
];

export { authProtectedRoutes, publicRoutes };
